<script setup lang="ts">
import { ref, onBeforeMount } from 'vue'

import { useClient } from '../../../utils/client-only'
import { useUrlHelper } from '../../../composables/use-url-helper'
import Change from '../../shared/reset-password/Change.vue'
import RequestLink from '../../shared/reset-password/RequestLink.vue'
import Success from '../../shared/reset-password/Success.vue'
import { useSessionStore } from '../../../stores/session'

const { isClient } = useClient()
const { getQueryParams } = useUrlHelper()

const sessionStore = useSessionStore()

const otp = ref<string | undefined>(undefined)
const view = ref<'default' | 'success' | 'reset'>('default')

onBeforeMount(() => {
  if (sessionStore.isLoggedIn) {
    window.location.href = '/'
  }
  otp.value = getQueryParams()?.otp ?? undefined
  view.value = otp.value ? 'reset' : 'default'
})
</script>

<template>
  <div class="bx-content">
    <template v-if="isClient">
      <RequestLink v-if="view==='default'"
                   :on-success="() => (view = 'success')" />
      <Success v-else-if="view==='success'" />
      <Change v-else-if="view==='reset'"
              :otp="otp" />
    </template>
  </div>
</template>
